export default __webpack_public_path__ + "f2fb38db94e210bde81f434d6db4546c.svg";